<script setup lang="ts">
  import { IconCheck } from '@gat-ship/icons'
  import {
    DropdownMenuItemIndicator,
    DropdownMenuRadioItem,
    type DropdownMenuRadioItemEmits,
    type DropdownMenuRadioItemProps,
    useForwardPropsEmits
  } from 'reka-ui'
  // fallow-ignore-next-line code-duplication
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    DropdownMenuRadioItemProps & { class?: HTMLAttributes['class'] }
  >()

  const emits = defineEmits<DropdownMenuRadioItemEmits>()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DropdownMenuRadioItem
    data-slot="dropdown-menu-radio-item"
    v-bind="forwarded"
    :class="
      cn(
        `focus:bg-accent focus:text-accent-foreground outline-hidden relative flex cursor-default select-none items-center justify-between gap-2 rounded-sm px-2 py-1.5 text-sm data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0`,
        props.class
      )
    "
  >
    <slot />
    <DropdownMenuItemIndicator>
      <IconCheck class="text-primary size-4" />
    </DropdownMenuItemIndicator>
  </DropdownMenuRadioItem>
</template>
